import React from 'react';
import { classNames } from 'tradera/utils/class-names';
import MediaQuery from 'react-responsive';

import { useTranslator } from 'tradera/lang/translate';
import type { DeviceName } from './ad-slot-utilities';
import { mapDeviceNameToViewport } from './ad-slot-utilities';
import ApplicationErrorBoundary from 'tradera/components/application-error-boundary/application-error-boundary';
import type { AdFormat } from './ad-format';
import HolidAdWrapper from './holid-ad-wrapper';
import { useLocation } from 'tradera/hooks/use-location';
import { selectIsGoogleAdsEnabled } from 'tradera/state/ads/selectors';
import { useSelector } from 'react-redux';

export type AdProps = {
    adFormat: AdFormat;
    className?: string;
    classNameAdWrapper?: string;
    deviceName: DeviceName;
};

export const Ad = ({
    adFormat,
    className,
    classNameAdWrapper,
    deviceName,
    ...otherProps
}: AdProps) => {
    const { t } = useTranslator();
    const isGoogleAdsEnabled = useSelector(selectIsGoogleAdsEnabled);
    const [minViewportWidth, maxViewportWidth] =
        mapDeviceNameToViewport(deviceName);
    const location = useLocation();

    if (!isGoogleAdsEnabled) {
        return null;
    }

    return (
        <MediaQuery minWidth={minViewportWidth} maxWidth={maxViewportWidth}>
            <div
                className={classNames('ad-slot-container', className)}
                {...otherProps}>
                <ApplicationErrorBoundary capture={false}>
                    <HolidAdWrapper
                        key={location.href}
                        adFormat={adFormat}
                        text={t('dfpAd_label')}
                        className={classNameAdWrapper}
                    />
                </ApplicationErrorBoundary>
            </div>
        </MediaQuery>
    );
};
